import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useGetMenuMaster } from 'api/menu';
import menuItem from 'menu-items';
import { DownOutlined } from '@ant-design/icons';

export default function Navigation() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster?.isDashboardDrawerOpened;
  const [openCollapses, setOpenCollapses] = useState({});

  const toggleCollapse = (id) => setOpenCollapses((prev) => ({ ...prev, [id]: !prev[id] }));

  const isChildActive = (children) => children?.some((c) => pathname === c.url || pathname.startsWith(c.url + '/'));

  const renderItem = (item) => {
    const Icon = item.icon;
    const isActive = pathname === item.url || pathname.startsWith(item.url + '/');
    return (
      <div
        key={item.id}
        onClick={() => navigate(item.url)}
        style={{
          display: 'flex', alignItems: 'center', gap: 12,
          margin: drawerOpen ? '2px 10px' : '2px 6px',
          padding: drawerOpen ? '9px 14px' : '10px',
          borderRadius: 10, cursor: 'pointer', position: 'relative',
          justifyContent: drawerOpen ? 'flex-start' : 'center',
          background: isActive ? 'linear-gradient(90deg, rgba(221,102,51,0.18), rgba(221,102,51,1))' : 'transparent',
          borderLeft: isActive && drawerOpen ? '3px solid #DD6633' : '3px solid transparent',
          transition: 'all 0.22s cubic-bezier(0.4,0,0.2,1)',
        }}
        className="nav-item-hover"
      >
        {Icon && (
          <span style={{ fontSize: 16, color: isActive ? '#DD6633' : 'rgba(255,255,255,0.55)', display: 'flex', alignItems: 'center', flexShrink: 0 }}>
            <Icon />
          </span>
        )}
        {drawerOpen && (
          <span style={{ fontSize: 13, fontWeight: isActive ? 600 : 400, color: isActive ? '#fff' : 'rgba(255,255,255,0.6)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {item.title}
          </span>
        )}
        {isActive && drawerOpen && (
          <span style={{ position: 'absolute', right: 10, width: 6, height: 6, borderRadius: '50%', background: '#DD6633', boxShadow: '0 0 6px #DD6633' }} />
        )}
      </div>
    );
  };

  const renderCollapse = (item) => {
    const Icon = item.icon;
    const childActive = isChildActive(item.children);
    const isOpen = openCollapses[item.id] ?? childActive;
    return (
      <div key={item.id}>
        <div
          onClick={() => toggleCollapse(item.id)}
          style={{
            display: 'flex', alignItems: 'center', gap: 12,
            margin: drawerOpen ? '2px 10px' : '2px 6px',
            padding: drawerOpen ? '9px 14px' : '10px',
            borderRadius: 10, cursor: 'pointer',
            justifyContent: drawerOpen ? 'flex-start' : 'center',
            background: childActive ? 'rgba(221,102,51,0.1)' : 'transparent',
            borderLeft: childActive && drawerOpen ? '3px solid rgba(221,102,51,0.5)' : '3px solid transparent',
            transition: 'all 0.22s',
          }}
          className="nav-item-hover"
        >
          {Icon && (
            <span style={{ fontSize: 16, color: childActive ? '#DD6633' : 'rgba(255,255,255,0.55)', display: 'flex', alignItems: 'center', flexShrink: 0 }}>
              <Icon />
            </span>
          )}
          {drawerOpen && (
            <>
              <span style={{ fontSize: 13, fontWeight: childActive ? 600 : 400, color: childActive ? '#fff' : 'rgba(255,255,255,0.6)', flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {item.title}
              </span>
              <DownOutlined style={{ fontSize: 10, color: 'rgba(255,255,255,0.4)', transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.22s' }} />
            </>
          )}
        </div>
        {isOpen && drawerOpen && (
          <div style={{ paddingLeft: 12 }}>
            {item.children?.map((child) => renderItem(child))}
          </div>
        )}
      </div>
    );
  };

  return (
    <nav style={{ padding: '8px 0' }}>
      {menuItem.items.map((group) => (
        <div key={group.id} style={{ marginBottom: 8 }}>
          {drawerOpen && group.title && (
            <div style={{ padding: '10px 20px 4px', fontSize: 10, fontWeight: 700, letterSpacing: '0.12em', color: 'rgba(255,255,255,0.3)', textTransform: 'uppercase' }}>
              {group.title}
            </div>
          )}
          {(group.children || []).map((item) => {
            if (item.type === 'collapse') return renderCollapse(item);
            return renderItem(item);
          })}
        </div>
      ))}
      <style>{`
        .nav-item-hover:hover { background: rgba(255,255,255,0.06) !important; transform: translateX(4px); border-left-color: rgba(221,102,51,0.4) !important; }
        .nav-item-hover:hover span { color: rgba(255,255,255,0.9) !important; }
      `}</style>
    </nav>
  );
}
